import React, { useState } from 'react';
import { Button } from 'antd';
import { RetweetOutlined } from '@ant-design/icons';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard.tsx';
import { ExpenseStatusEditModal } from './components/expense-status-edit-modal';
import type { IExpenseStatusEditProps } from './types';

export const ExpenseStatusEditComponent: React.FC<IExpenseStatusEditProps> = (props) => {
  const { expenseId, currentStatus } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpen = () => setIsModalOpen(true);
  const handleClose = () => setIsModalOpen(false);

  return (
    <>
      <Button icon={<RetweetOutlined />} onClick={handleOpen}>
        Status
      </Button>
      <ExpenseStatusEditModal
        isOpen={isModalOpen}
        currentStatus={currentStatus}
        expenseId={expenseId}
        onClose={handleClose}
      />
    </>
  );
};

export const ExpenseStatusEdit = withRoleGuard<IExpenseStatusEditProps>(ExpenseStatusEditComponent, [
  UserRole.admin,
  UserRole.assistant,
  UserRole.accountant,
]);
